import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'
import {useRefraPlanningTracking} from '../tracking'

export const useAddMaterialInstallation = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()
  const tracking = useRefraPlanningTracking()

  return useRefraMutation({
    mutationFn: mutations.addMaterialInstallation,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useAddMaterialInstallation')
        .extras({errorDetails})
        .error('Error occurred while adding a new material to shutdown')

      spawnErrorToast(t('error.addMaterialInstallation'))
    },
    onSuccess: async (_, {plantUpmId, kilnUpmId, shutdownId, material}) => {
      tracking.materialInstallation.add(material)

      await queryClient.invalidateQueries({
        queryKey: [
          'kilnReplacement',
          {
            plantUpmId,
            kilnUpmId,
            shutdownId
          }
        ]
      })
      spawnSuccessToast(t('success.addMaterialInstallation'))
    }
  })
}
